import { tv } from 'tailwind-variants'

export const screenStyles = tv({
	slots: {
		base: 'flex bg-palette_3 web:w-full',
		keyboardAvoidingView: 'flex h-full w-full',
		screenContainer: 'flex h-full w-full',
		screenContent: 'h-full w-full',
	},
})
